import { render, staticRenderFns } from "./ErrorIcon.vue?vue&type=template&id=6ea34e00"
import script from "./ErrorIcon.vue?vue&type=script&lang=js"
export * from "./ErrorIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports